var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    { staticClass: "info-row" },
    [
      _c("b-col", { staticClass: "entry-label", attrs: { sm: _vm.sizing } }, [
        _c(
          "span",
          {
            directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
            staticClass: "entry-label-text",
            attrs: { title: _vm.tip },
          },
          [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "entry-info", attrs: { sm: 12 - _vm.sizing } },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }